/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2021, Zumper
 */

import {
  NAVBAR_ALERTS,
  NAVBAR_FAVORITES,
  NAVBAR_LIST,
  NAVBAR_MAP,
  NAVBAR_MESSAGED,
} from '@zcode/nr/es/shared/constants/analytics'

export const getOrigin = (
  isFavoritesView?: boolean,
  isHomepageView?: boolean,
  isMessagedView?: boolean,
  isSavedSearchesView?: boolean,
  mobileViewType?: string
) => {
  let origin:
    | typeof NAVBAR_ALERTS
    | typeof NAVBAR_FAVORITES
    | typeof NAVBAR_LIST
    | typeof NAVBAR_MAP
    | typeof NAVBAR_MESSAGED
    | 'Nav Search'
  if (isFavoritesView) {
    origin = NAVBAR_FAVORITES
  } else if (isMessagedView) {
    origin = NAVBAR_MESSAGED
  } else if (isSavedSearchesView) {
    origin = NAVBAR_ALERTS
  } else if (isHomepageView) {
    origin = 'Nav Search'
  } else if (mobileViewType === 'map') {
    origin = NAVBAR_MAP
  } else {
    origin = NAVBAR_LIST
  }
  return origin
}
